import React from 'react';
import { withTheme } from 'styled-components';
import TeamSummaryMatchupDataContainer from '../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import MatchupDataContainer from '../Matchup/containers/MatchupDataContainer';
import LineScoreDataContainer from '../LineScore/containers/LineScoreDataContainer';
import BroadcastersDataContainer from '../Broadcasters/containers/BroadcastersDataContainer';
import { Title, LiveMiniWrapper, InfoWrapper, LiveMiniScoreWrapper, LiveMiniMatchupWrapper, MainGameInfoWrapper, GameInfoWrapper } from './liveMini.style.js';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import { GDBREAKPOINTS_LIVE_MINI } from '@gameday/components/themes/breakpoints';

const LiveTeamSummaryProps = {
    displayRecords: true,
    hideTeamNames: false
};

const {
    SM_MAX
} = GDBREAKPOINTS_LIVE_MINI;

const trackingConfig = ['Live', 'TeamSummaryMatchup'];

const LiveMini = () => {
    const followTheGameLabel = useTranslator('label_follow_the_game', 'Follow the Game');
    const lineScoreLabel = useTranslator('label_linescore', 'Line Score');
    const isMobile = useMedia({ maxWidth: SM_MAX });

    return (
        <LiveMiniWrapper>
            <LiveMiniScoreWrapper>
                <TeamSummaryMatchupDataContainer {...LiveTeamSummaryProps} useTri={true} componentName={trackingConfig} />
            </LiveMiniScoreWrapper>
            <LiveMiniMatchupWrapper>
                <MatchupDataContainer />
            </LiveMiniMatchupWrapper>
            <MainGameInfoWrapper>
                <GameInfoWrapper>
                    {!isMobile && <Title>{lineScoreLabel}</Title>}
                    <InfoWrapper>
                        <LineScoreDataContainer />
                    </InfoWrapper>
                </GameInfoWrapper>
                <GameInfoWrapper>
                    <Title>{followTheGameLabel}</Title>
                    <InfoWrapper className={'right'}>
                        <BroadcastersDataContainer />
                    </InfoWrapper>
                </GameInfoWrapper>
            </MainGameInfoWrapper>
        </LiveMiniWrapper>
    );
};

export default withTheme(LiveMini);
